<template>
    <div class="main">

        <div v-if="loading" class="u-text-center" style="min-height: 585px; display: flex; justify-content: center; align-items: center;">
            <img src="/public/img/loading-bar.gif" />
        </div>

        <div v-if="Object.keys(dados).length !== 0 && !loading">
            <el-form @submit.native.prevent="onSubmitRenovaMatricula" :model="dados" ref="dados" label-position="top">
              
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12" :md="12">
                        <el-form-item label="Nome do Aluno" key="nome_aluno">
                            <el-input readonly v-model="dados.aluno.nome" maxlength="191" class="readonly"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="4" :md="4">
                        <el-form-item label="Data de Nascimento" prop="aluno.data_nascimento" :rules="[$requiredBlur, $dataBlur]" key="aluno.data_nascimento">
                            <el-input v-model="dados.aluno.data_nascimento" maxlength="191" v-mask="'##/##/####'"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="4" :md="4">
                        <el-form-item label="Telefone / Celular" key="celular">
                            <el-input v-model="dados.aluno.celular" maxlength="191" v-mask="'(##) #########'" v-on:blur="formatData('celular', 13)"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="4" :md="4">
                        <el-form-item label="Outro Telefone / Celular" key="celular_outro">
                            <el-input v-model="dados.aluno.celular_outro" maxlength="191" v-mask="'(##) #########'" v-on:blur="formatData('celular_outro', 13)"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12" :md="12">
                        <el-form-item label="Filiação 1 (preferencialmente nome da mãe)" key="mae">
                            <el-input readonly v-model="dados.aluno.mae" maxlength="191" class="readonly"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12">
                        <el-form-item label="Filiação 2" key="pai">
                            <el-input v-model="dados.aluno.pai" maxlength="191" v-on:blur="formatData('pai')"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12" :md="12">
                        <el-form-item label="Responsável" key="responsavel">
                            <el-input v-model="dados.aluno.responsavel" maxlength="191" v-on:blur="formatData('responsavel')"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6" :md="6">
                        <el-form-item label="Parentesco" key="parentesco">
                            <el-select v-model="dados.aluno.parentesco">
                                <el-option key="NÃO DECLARADA" label="NÃO DECLARADA" value="NÃO DECLARADA"></el-option>
                                <el-option key="PAI" label="PAI" value="PAI"></el-option>
                                <el-option key="MAE" label="MAE" value="MAE"></el-option>
                                <el-option key="AVÔ(Ó)" label="AVÔ(Ó)" value="AVÔ(Ó)"></el-option>
                                <el-option key="TIO(A)" label="TIO(A)" value="TIO(A)"></el-option>
                                <el-option key="IRMÃO(Ã)" label="IRMÃO(Ã)" value="IRMÃO(Ã)"></el-option>
                                <el-option key="PRIMO(A)" label="PRIMO(A)" value="PRIMO(A)"></el-option>
                                <el-option key="PADRASTO" label="PADRASTO" value="PADRASTO"></el-option>
                                <el-option key="MADRASTA" label="MADRASTA" value="MADRASTA"></el-option>
                                <el-option key="OUTRO" label="OUTRO" value="OUTRO"></el-option>                         
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6" :md="6">
                        <el-form-item label="Recebe Auxílio Brasil" prop="aluno.recebe_bolsa_familia" :rules="[$requiredChange]" key="recebe_bolsa_familia">
                            <el-select v-model="dados.aluno.recebe_bolsa_familia">
                                <el-option :key="true" label="SIM" :value="true"></el-option>
                                <el-option :key="false" label="NÃO" :value="false"></el-option>                                
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="CPF" prop="aluno.cpf" key="cpf">
                            <el-input readonly v-model="dados.aluno.cpf" maxlength="191"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="RG" prop="aluno.rg" key="rg">
                            <el-input readonly v-model="dados.aluno.rg" maxlength="191"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="Registro Novo" prop="aluno.registro_nasc_novo" key="registro_nasc_novo">
                            <el-input readonly v-model="dados.aluno.registro_nasc_novo" maxlength="191"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="3" :md="3">
                        <el-form-item label="CEP" prop="aluno.cep" :rules="[$requiredBlur]" key="cep">
                            <el-input v-model="dados.aluno.cep" maxlength="191" v-mask="'#####-###'" v-on:blur="getEnderecoByCep()"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="9" :md="9">
                        <el-form-item label="Logradouro" prop="aluno.logradouro" :rules="[$requiredBlur]" key="logradouro">
                            <el-input v-model="dados.aluno.logradouro" maxlength="191" v-on:blur="formatData('logradouro')"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="2" :md="2">
                        <el-form-item label="Número" prop="aluno.numero" :rules="[$requiredBlur]" key="numero">
                            <el-input v-model="dados.aluno.numero" maxlength="191" v-on:blur="formatData('numero')"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="4" :md="4">
                        <el-form-item label="Bairro" prop="aluno.bairro" key="bairro">
                            <el-input readonly v-model="dados.aluno.bairro" maxlength="191" class="readonly"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6" :md="6">
                        <el-form-item label="Cidade" prop="aluno.cidade" key="cidade">
                            <el-input readonly v-model="dados.aluno.cidade.nome" maxlength="191" class="readonly"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>                

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="Possui Internet na Residência?" prop="possui_internet" key="possui_internet">
                            <el-select v-model="dados.aluno.possui_internet" clearable>
                                <el-option :key="true" label="SIM" :value="true"></el-option>
                                <el-option :key="false" label="NÃO" :value="false"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="Possui Computador na Residência?" prop="possui_computador" key="possui_computador">
                            <el-select v-model="dados.aluno.possui_computador" clearable>
                                <el-option :key="true" label="SIM" :value="true"></el-option>
                                <el-option :key="false" label="NÃO" :value="false"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="Qtd. Smartphones na Residência" key="qtd_smartphones">
                            <el-input v-model="dados.aluno.qtd_smartphones" maxlength="191"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12" :md="12">
                        <el-form-item label="Curso Nacional" prop="referencia_nacional" :rules="[$requiredChange]" key="referencia_nacional">
                            <el-select v-model="dados.referencia_nacional"  @change="getTurmas()">
                                <template v-for="(curso, i) in cursosNacionais">
                                    <el-option :key="i" :label="curso.nome" :value="curso.referencia_nacional"></el-option>
                                </template>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12">
                        <el-form-item label="Turma" prop="turma_id" :rules="[$requiredChange]" key="turma_id">
                            <el-select v-model="dados.turma_id">
                                <el-option-group v-for="(curso, i) in selectTurmas" :key="i" :label="i">
                                    <template v-for="item in curso">
                                       <el-option :key="item.id" :label="item.vagas_disponiveis" :value="item.id"></el-option>
                                    </template>                                
                                </el-option-group>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10" v-for="(item, i) in dados.aluno.deficiencias" :key="i">
                    <el-col :xs="24" :sm="17" :md="17">
                        <el-form-item label="Deficiência" prop="deficiencias" key="deficiencias">
                            <el-select v-model="dados.aluno.deficiencias[i].deficiencia_id" clearable>
                                <el-option
                                    style="text-transform: uppercase;"
                                    v-for="(item, i) in deficiencias"
                                    :key="i"
                                    :label="item.nome"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6" :md="6">
                        <el-form-item label="CID-10" prop="cid10" key="cid10">                               
                            <el-input v-model="dados.aluno.deficiencias[i].cid10" maxlength="191"></el-input>                               
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="1" :md="1">

                        <el-button v-if="i != (dados.aluno.deficiencias && dados.aluno.deficiencias.length - 1)" @click="removerDeficiencia(i)" type="danger" icon="el-icon-delete" style="margin-top: 21px;"></el-button>

                        <el-button v-if="i == (dados.aluno.deficiencias && dados.aluno.deficiencias.length - 1)" @click="adicionarDeficiencia()" type="primary" style="margin-top: 21px;">
                            <i class="fas fa-plus"></i>
                        </el-button>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="(dados.transporte_escolar) ? 6 : 8" :md="(dados.transporte_escolar) ? 6 : 8">
                        <el-form-item label="Autoriza o uso da imagem do Aluno?" prop="autoriza_uso_imagem" :rules="[$requiredChange]" key="">
                            <el-select v-model="dados.autoriza_uso_imagem">
                                <el-option :key="true" label="SIM" :value="true"></el-option>
                                <el-option :key="false" label="NÃO" :value="false"></el-option>                                
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="(dados.transporte_escolar) ? 6 : 16" :md="(dados.transporte_escolar) ? 6 : 16">
                        <el-form-item label="Necessita de Transporte Escolar?" prop="transporte_escolar" :rules="[$requiredChange]" key="dados.transporte_escolar">
                            <el-select v-model="dados.transporte_escolar">
                                <el-option :key="true" label="SIM" :value="true"></el-option>
                                <el-option :key="false" label="NÃO" :value="false"></el-option>                                
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6" :md="6" v-if="dados.transporte_escolar">
                        <el-form-item label="Tipo de Transporte" prop="tipo_transporte_id" :rules="[$requiredChange]" key="tipo_transporte_id">
                            <el-select v-model="dados.tipo_transporte_id">
                                <el-option v-for="(transporte, i) in transportes" :key="i" :label="transporte.nome" :value="transporte.id"></el-option>                                
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6" :md="6" v-if="dados.transporte_escolar">
                        <el-form-item label="Rota do Transporte" prop="rota" key="rota">
                            <el-input v-model="dados.rota" maxlength="40"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row> 
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24">
                        <el-form-item label="Observação" key="observacao">
                            <el-input v-model="dados.observacao" maxlength="191"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>   

                <div v-if="input_autorizacao">
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Código de Autorização" prop="autorizacao_smed" key="autorizacao_smed">
                                <el-input v-model="dados.autorizacao_smed" maxlength="191"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-alert title="Você poderá informar um código de autorização gerado pela SMED para concluir a matrícula." type="warning"></el-alert>
                </div>              

                <el-alert class="u-mt-10" v-if="alerta_sem_curso" title="Atenção! A sua instituição não possui turmas compatíveis com o curso que o aluno está cursando." type="warning" effect="dark" :closable="false"></el-alert>
                <!-- <el-alert class="u-mt-10" v-if="compativel_eja" title="Atenção: Idade do Aluno compatível com turma de Eja" type="info" effect="dark" :closable="false"></el-alert> -->
                <el-alert class="u-mt-10" v-if="Object.keys(dados).length !== 0 && dados.aluno && dados.aluno.deficiencias && dados.aluno.deficiencias.length > 0" title="Aluno (a) possui Necessidade Especial." type="warning" effect="dark" :closable="false"></el-alert>
                 
                <div class="u-text-right u-mt-10">
                    <el-button type="primary" native-type="submit">RENOVAR MATRÍCULA</el-button>
                </div>
                

            </el-form>
        </div>

    </div>
</template>
<script>

import Vue from 'vue'

export default {
    props: ['aluno'],
    data: () => ({
        input_autorizacao: false,
        alerta_sem_curso: false,
        loading: false,
        selectTurmas: [],
        transportes: [],
        deficiencias: [],
        compativel_acelera_um: false,
        compativel_acelera_dois: false,
        compativel_acelera_tres: false,
        compativel_eja: false,
        dados: {
            transporte_escolar: '',
            tipo_transporte_id: '',
            curso_id: '',
            turma_id: '',
            referencia_nacional: '',
            autoriza_uso_imagem: '',
            observacao: '',
            rota: '',
            cid10: '',
            autorizacao_smed: '',
            aluno:{
                cep: '',
                nome: '',
                data_nascimento: '',
                celular: '',
                mae: '',
                pai: '',                
                celular_outro: '',
                responsavel: '',
                parentesco: '',
                recebe_bolsa_familia: '',
                cep: '',
                logradouro: '',
                numero: '',
                bairro: '',
                cidade: {
                    nome: ''
                },
                deficiencias: [{
                    deficiencia_id: '',
                    cid10: '',
                    nome: ''
                }],
                possui_internet: '',
                possui_computador: '',
                qtd_smartphones: ''
            }
        },
        cursosNacionais: []
    }),
    mounted () {
      
      this.loadingTiposTransportes();
      this.loadingDeficiencias();
    },
    methods: {
        adicionarDeficiencia(){
            this.dados.aluno.deficiencias.push({
                deficiencia_id: '',
                cid10: '',
                nome: ''
            });
        },
        removerDeficiencia(i){
            this.dados.aluno.deficiencias.splice(i, 1);
        },
        getMatriculaForRenovacao(id){

            // window.eventBus.$emit('loading', true);
            this.loading = true;

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/matricula/getMatriculaForRenovacao/${id}`, this.$store.getters.getHeaderAuth).then(response => {
                
                if(response.data.aluno.data_nascimento)
                    response.data.aluno.data_nascimento = this.$moment(response.data.aluno.data_nascimento).format('DD/MM/YYYY');

                this.dados = response.data;

                this.getRefNacional();

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        getRefNacional(){

            if(!this.dados.referencia_nacional){

                this.loading = false;
                return false;
            }

            let p = this.$store.state.config.periodo.id;
            let i = this.dados.instituicao_id;

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/curso/getRefNacionalByInstituicao`, {i, p, referencia_nacional: this.dados.referencia_nacional}, this.$store.getters.getHeaderAuth).then(response => {
                   
                this.cursosNacionais = JSON.parse(JSON.stringify(response.data));

                let existe = false;

                for(let i in this.cursosNacionais){

                    if(this.cursosNacionais[i].referencia_nacional == this.dados.referencia_nacional){

                        existe = true;
                    }

                }

                if(!existe){

                    if(this.cursosNacionais.length == 0){
                        
                        this.alerta_sem_curso = true;
                    }

                    this.loading = false;
                    // window.eventBus.$emit('loading', false);
                    this.dados.referencia_nacional = '';
                    return false;
                }

                this.getTurmas();
 
            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        getTurmas(){

            if(!this.dados.referencia_nacional){

                this.loading = false;
                return false;
            }

            if(!this.loading){
            
                window.eventBus.$emit('loading', true);
            }

            let i = this.dados.instituicao_id;
            let p = this.$store.state.config.periodo.id;

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/turma/getAllByReferenciaNacional`, {instituicao_id: i, periodo_letivo_id: p, referencia_nacional: this.dados.referencia_nacional, data_nascimento: this.dados.aluno.data_nascimento}, this.$store.getters.getHeaderAuth).then(response => {

                this.dados.turma_id = '';
                this.selectTurmas = response.data.turmas;
                this.compativel_acelera_um = response.data.compativel_acelera_um;
                this.compativel_acelera_dois = response.data.compativel_acelera_dois;
                this.compativel_acelera_tres = response.data.compativel_acelera_tres;
                this.compativel_eja = response.data.compativel_eja;
                window.eventBus.$emit('loading', false);
                this.loading = false;
 
            }).catch((error) => { this.loading = false; window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
            
        },
        loadingTiposTransportes(){

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/transporte/getAll`, this.$store.getters.getHeaderAuth).then(response => {

                this.transportes = response.data;

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        loadingDeficiencias(){
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/deficiencia/getAll`, this.$store.getters.getHeaderAuth).then(response => {

                this.deficiencias = response.data;

            }).catch((error) => { this.$store.commit('throwException', error); });
        },
        onSubmitRenovaMatricula(){

            // console.log(this.dados);
            // return false;

            this.$refs.dados.validate((valid) =>{ if(valid){

                // window.eventBus.$emit('loading', true);
                
                let deficiencias = [];
                for(let i in this.dados.aluno.deficiencias){
                    if(this.dados.aluno.deficiencias[i].deficiencia_id){
                        deficiencias.push(this.dados.aluno.deficiencias[i]);
                    }else if(!this.dados.aluno.deficiencias[i].deficiencia_id && this.dados.aluno.deficiencias[i].cid10){
                        this.$alert('Você informou a cid e não informou a deficiência.', 'Atenção', { confirmButtonText: 'OK' });
                        return;
                    }
                }
                if(deficiencias.length > 0){
                    for(let i in deficiencias){
                        for(let j in this.deficiencias){

                            if(deficiencias[i].deficiencia_id == this.deficiencias[j].id){
                                deficiencias[i].nome = this.deficiencias[j].nome;
                            }
                        }
                    }
                }

                this.loading = true;

                this.dados.aluno.deficiencias = deficiencias.length > 0 ? deficiencias : null; 

                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/matricula/renovaMatricula`, this.dados, this.$store.getters.getHeaderAuth).then(response => {

                    if(typeof response.data.throw !== 'undefined'){

                        if(this.dados.autorizacao_smed){

                            window.eventBus.$emit('throw', response.data.throw);
                            this.$alert('O código de autorização informado não é válido.', 'Atenção', { confirmButtonText: 'OK' });

                        }else{

                            window.eventBus.$emit('throw', response.data.throw);
                            this.input_autorizacao = true;
                        }

                    }else{

                        window.eventBus.$emit('print', {url: '/api/pdf/renderRequerimentoMatricula', param: response.data.id});
                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                        this.$emit('closeModal');  
              
                    }

                    // window.eventBus.$emit('loading', false);
                    this.loading = false;

                }).catch((error) => { this.loading = false; /*window.eventBus.$emit('loading', false);*/ this.$store.commit('throwException', error); });

            }else{ window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'}); }});

        },
        getEnderecoByCep(){

            if(this.dados.aluno.cep.length < 9){

                this.dados.aluno.cep = '';
                return false;
            }

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/cep/getEnderecoByCep/` + this.dados.aluno.cep.replace(/\-/g,''), this.$store.getters.getHeaderAuth).then(response => {
         
                if(response.data.length == 0){
                    
                    this.dados.aluno.cep = '';
                    this.dados.aluno.logradouro = '';
                    this.dados.aluno.bairro = '';
                    this.dados.aluno.cidade.nome = '';
                    this.dados.aluno.cidade.id = '';
                    window.eventBus.$emit('alert', {msg: 'Atenção! Cep inválido.', type: 'warning'});
                    return false;
                }

                this.dados.aluno.logradouro = (response.data.logradouro) ? response.data.logradouro.nome : '';
                this.dados.aluno.bairro = (response.data.bairro) ? response.data.bairro.nome : '';
                this.dados.aluno.cidade.nome = (response.data.cidade) ? response.data.cidade.nome : '';
                this.dados.aluno.cidade.id = (response.data.cidade) ? response.data.cidade.id : '';

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        formatData(field, size = null){
                        
            if(!this.dados[field])
                return false;

            if(size && this.dados[field].length < size)
                this.dados[field] = '';            

            this.dados[field] = this.dados[field].toUpperCase();

            this.dados[field] = this.$removerAcentos(this.dados[field]);
        }

    },
    watch: {
        aluno: {
            immediate: true,
            handler (value) {

                this.getMatriculaForRenovacao(value);
            }
        },
    }
}
</script>
<style>

    .matriculado{
        background-color: #c4f9be !important;
    }

</style>
